import { TrackingEvent } from '../../Services/Tracking/TrackingService';
import RiskCalculatorInput from './RiskCalculatorInput';
import { MonthlyRiskCompositeModel, RiskRequest, TabEventKeyType } from './RiskDefinitions';

interface ICalculatorInputProps {
    className: string;
    riskRequest: RiskRequest;
    setRiskRequest: (riskRequest: RiskRequest, index: number) => void;
    fieldName: keyof MonthlyRiskCompositeModel;
    disabled?: boolean;
    handleGridTabNavigation: (columnIndex: number, rowIndex: number, direction: TabEventKeyType) => void;
    validation?: RegExp;
    track: TrackingEvent;
}

const RiskCalculatorInputRow: React.FC<ICalculatorInputProps> = (props: ICalculatorInputProps) => {
    const riskRequest = props.riskRequest.risks;

    return (
        <div className={props.className}>
            {riskRequest!.map((x, index) => (
                <RiskCalculatorInput
                    key={`${props.fieldName}_${x.dataYear}_${x.dataMonth}`}
                    riskRequest={props.riskRequest}
                    setRiskRequest={(newRiskRequest) => {
                        props.setRiskRequest(newRiskRequest, index);
                    }}
                    fieldName={props.fieldName}
                    disabled={props.disabled}
                    index={index}
                    handleGridTabNavigation={props.handleGridTabNavigation}
                    validation={props.validation}
                    track={props.track}
                />
            ))}
        </div>
    );
};

export default RiskCalculatorInputRow;
